import {AssistantError} from './AssistantError.js'

export class UpdateChatAssistantError extends AssistantError {
  static create(message) {
    return new UpdateChatAssistantError(message)
  }
}
